import React, { useEffect } from 'react';
import { Prompt } from 'react-router-dom';
import PropTypes from '+/instances/propTypesInstance';

export const ExitPrompt = ({ shouldPrompt, message }) => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'test') {
      window.onbeforeunload = message;
    }
    return () => {
      window.onbeforeunload = null;
    };
  });
  return <Prompt when={shouldPrompt} message={message} />;
};

ExitPrompt.propTypes = {
  shouldPrompt: PropTypes.bool.isRequired,
  message: PropTypes.func.isRequired,
};
